exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".face-icon-35 {\n  width: 35px;\n  height: 35px; }\n\n.face-icon-45 {\n  width: 45px;\n  height: 45px; }\n\n.face-icon-55 {\n  width: 55px;\n  height: 55px; }\n\n.face-icon-75 {\n  width: 75px;\n  height: 75px; }\n\n.face-icon-95 {\n  width: 95px;\n  height: 95px; }\n\n.face-icon-200 {\n  width: 200px;\n  height: 200px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/components/face-icon/face-icon.component.scss
// module id = ../../../../../src/app/components/face-icon/face-icon.component.scss
// module chunks = main